var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.7746C3.3375 17.7746 2.98425 17.6276 2.69025 17.3336C2.39675 17.0401 2.25 16.6871 2.25 16.2746V5.77461C2.25 5.36211 2.39675 5.00886 2.69025 4.71486C2.98425 4.42136 3.3375 4.27461 3.75 4.27461H10.4438L8.94375 5.77461H3.75V16.2746H14.25V11.0621L15.75 9.56211V16.2746C15.75 16.6871 15.6033 17.0401 15.3097 17.3336C15.0157 17.6276 14.6625 17.7746 14.25 17.7746H3.75ZM12.1312 4.70586L13.2 5.75586L8.25 10.7059V11.7746H9.3L14.2687 6.80586L15.3375 7.85586L10.3687 12.8246C10.2312 12.9621 10.072 13.0716 9.891 13.1531C9.7095 13.2341 9.51875 13.2746 9.31875 13.2746H7.5C7.2875 13.2746 7.1095 13.2029 6.966 13.0594C6.822 12.9154 6.75 12.7371 6.75 12.5246V10.7059C6.75 10.5059 6.7875 10.3151 6.8625 10.1336C6.9375 9.95261 7.04375 9.79336 7.18125 9.65586L12.1312 4.70586ZM15.3375 7.85586L12.1312 4.70586L14.0062 2.83086C14.3062 2.53086 14.6658 2.38086 15.0848 2.38086C15.5033 2.38086 15.8562 2.53086 16.1437 2.83086L17.1937 3.89961C17.4812 4.18711 17.625 4.53711 17.625 4.94961C17.625 5.36211 17.4812 5.71211 17.1937 5.99961L15.3375 7.85586Z",
    fill: "url(#paint0_linear_1973_1639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1973_1639",
    x1: 2.25,
    y1: 10.0777,
    x2: 17.625,
    y2: 10.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.fc33e259da55f6d68e4847f863dffc96.svg";
export { ForwardRef as ReactComponent };